import PDFDocument from 'pdfkit/js/pdfkit.standalone.js';
import { COLOR_BLACK, FONT, FONT_SIZE_MEDIUM, FONT_SIZE_SMALL } from '../variables';
import { fetchWebImage, isWebImage } from './image';
import { cmToPoint } from './units';

export async function renderHeader(pdf: PDFDocument, body: any) {
	const logoMaxWidth = cmToPoint(6.5);
	const logoMaxHeight = cmToPoint(3);
	const logoSpace = cmToPoint(0.96);

	const resetY = pdf.y;
	const resetX = pdf.x;

	if (body.layout?.header?.alignment?.toUpperCase() === 'RIGHT') {
		const logoY = resetY;

		if (body.layout?.header?.address) {
			// SPACING
			pdf.y = resetY;
			pdf.y -= 3.7;

			renderAddress(pdf, body);
		}
		if (body.header.logo && body.layout?.header?.logo) {
			const logoX = pdf.page.width - pdf.page.margins.right - logoMaxWidth;

			await renderLogo(pdf, body, logoX, logoY, logoMaxWidth, logoMaxHeight);
		}
	} else {
		if (body.header.logo && body.layout?.header?.logo) {
			await renderLogo(pdf, body, pdf.x, pdf.y, logoMaxWidth, logoMaxHeight);
		}

		if (body.layout?.header?.address) {
			pdf.x += logoMaxWidth + logoSpace;
			// SPACING
			pdf.y = resetY;
			pdf.y -= 3.7;

			renderAddress(pdf, body);
		}
	}

	pdf.x = resetX;
	pdf.y = 140.65104284; // always same height, doesn't matter if logo is missing, GLN, Address2 ...
}

async function renderLogo(pdf: PDFDocument, body: any, x: number, y: number, logoMaxWidth: number, logoMaxHeight: number) {
	try {
		const image = isWebImage(body.header.logo) ? await fetchWebImage(body.header.logo) : body.header.logo;

		pdf.image(image, x, y, {
			width: logoMaxWidth,
			height: logoMaxHeight,
			fit: [logoMaxWidth, logoMaxHeight]
		});
	} catch (err) {
		console.error(err);
	}
}

function renderAddress(pdf: PDFDocument, body: any) {
	const textOptions = {
		lineGap: 1
	};

	pdf.font(FONT).fontSize(FONT_SIZE_MEDIUM).fillColor(COLOR_BLACK);

	pdf.text(body.header.company);

	pdf.y += cmToPoint(0.35);

	pdf.fontSize(FONT_SIZE_SMALL);

	const startX = pdf.x;
	const startY = pdf.y;

	let width = 0;

	if (body.header.name) {
		pdf.text(body.header.name, textOptions);
		width = Math.max(pdf.widthOfString(body.header.name, textOptions), width);
	}

	if (body.header.address1) {
		pdf.text(body.header.address1, textOptions);
		width = Math.max(pdf.widthOfString(body.header.address1, textOptions), width);
	}

	if (body.header.address2) {
		pdf.text(body.header.address2, textOptions);
		width = Math.max(pdf.widthOfString(body.header.address2, textOptions), width);
	}

	if (body.header.zipCode || body.header.city) {
		const formatted = `${body.header.zipCode} ${body.header.city}`.trim();
		pdf.text(formatted, textOptions);
		width = Math.max(pdf.widthOfString(formatted, textOptions), width);
	}

	if (body.header.country) {
		pdf.text(body.header.country, textOptions);
		width = Math.max(pdf.widthOfString(body.header.country, textOptions), width);
	}

	pdf.x = startX + width + cmToPoint(1.35);
	pdf.y = startY;

	if (body.header.phoneNumber) {
		pdf.text(body.header.phoneNumber, textOptions);
	}

	if (body.header.faxNumber) {
		pdf.text(body.header.faxNumber, textOptions);
	}

	if (body.header.email) {
		pdf.text(body.header.email, textOptions);
	}

	if (body.header.website) {
		pdf.text(body.header.website, textOptions);
	}
}
